import Vue from "vue";

import { Loading } from "element-ui";

export const servicesLoading = (target, text, lock = true) => Loading.service({
    target: target,//loading需要覆盖的DOM节点
    text: text,
    lock, //同v-loading的修饰符
    // backgroundColor: 'rgba(55,55,55,0.4)',//背景色
    // spinner: 'el-icon-loading',//加载图标
})

export const topMenu = () => {
    return {
        menuName: "主类目",
        id: "0",
    }
}


export const handleRouters = (router) => {
    return new Promise((resolve, Reject) => {
        let res = [];
        if (!router) {
            resolve(res);
        }
        router.forEach(async (v) => {
            let t;
            let handleRouterRes = await handleRouters(v.children);
            if (v.component && v.children && v.children.length > 0) {
                t = {
                    ...v,
                    path: v.path,
                    meta: {
                        ...v.meta,
                        notPage: !v.component
                    },
                    component: { render(c) { return c('router-view') } },
                    redirect: { path: v.path },
                    children: [{
                        ...v,
                        meta: {
                            ...v.meta,
                            notPage: !v.component
                        },
                        component: loadView(v.component || 'de'),
                        children: []
                    }].concat(handleRouterRes)
                }
            } else {
                t = {
                    ...v,
                    meta: {
                        ...v.meta,
                        notPage: !v.component
                    },
                    component: loadView(v.component || "de"),
                };
                if (v.children && v.children.length > 0) {
                    t.children = handleRouterRes;
                }
            }
            res.push(t);
        });
        resolve(res);
    }).then(res => {
        return res;
    }).catch(e => {
        console.error('handleRouters ex ', e)
    });
}


export const loadView = (component) => {
    if (!component) {
        return null;
    }
    if (process.env.NODE_ENV == "development") {
        return (resolve) => require([`@/pages/${component}`], resolve);
    } else {
        // 使用 import 实现生产环境的路由懒加载
        return () => import(`@/pages/${component}`);
    }
}


// 二进制数组 生成文件
export const downloadFileByByte = (data, fileName) => {
    const blob = buildBlobByByte(data);
    downloadFile(blob, fileName);
};

// 将Base64文件转为 Blob
function buildBlobByByte(data) {
    const raw = window.atob(data);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array]);
}
function downloadFile(blob, fileName) {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    // 此写法兼容可火狐浏览器
    document.body.appendChild(link);
    const evt = document.createEvent("MouseEvents");
    evt.initEvent("click", false, false);
    link.dispatchEvent(evt);
    document.body.removeChild(link);
}


export const openNewPage = (url, type = '_blank') => {
    window.open(url, type)
}

const browser = () => {
    const u = navigator.userAgent
    return {
        edge: u.indexOf('Edge') > -1, // Edge内核
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1, // 是否web应用程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === 'qq' // 是否QQ
    }
}

export const hasPermi = (value) => {
    if (value && value instanceof Array && value.length > 0) {
        const all_permission = "*:*:*";
        const permissions = Vue.prototype.$storageUtil.getPermissions() || [];
        const hasPermissions = permissions.some(permission => {
            return all_permission === permission || value.includes(permission)
        })
        return hasPermissions;
    } else {
        throw new Error(`请设置操作权限标签值`)
    }
}


export const getColor = (value) => {
    if (value == 'primary') {
        return 'var(--qs-primary-color)';
    } else if (value == 'success') {
        return 'var(--qs-success-color)';
    } else if (value == 'warning') {
        return 'var(--qs-warning-color)';
    } else if (value == 'danger' || value == 'error') {
        return 'var(--qs-danger-color)';
    } else if (value == 'info') {
        return 'var(--qs-info-color)';
    } else if (value == 'text') {
        return 'var(--qs-regular-text-color)';
    }
}



export const getOrderPayStatusEnumType = (_enum) => {
    if (!_enum || !_enum.Name) {
        return;
    }
    if (_enum.Name == 'Wait') {
        return 'warning';
    } else if (_enum.Name == 'Paid') {
        return 'success';
    } else if (_enum.Name == 'Expired') {
        return "info";
    } else if (_enum.Name == 'Cancel') {
        return "info";
    }
}

// 加法
export const sum = (list) => {
    if (typeof list == 'undefined' || list.length == 0) {
        return '0.00';
    }
    if (list.length == 1) {
        return toFixedFun(Number(list[0]), 2)
    }
    return toFixedFun(list.reduce(function (prev, curr, idx, arr) {
        return Number(prev) + Number(curr);
    }), 2)
}

// 加法
export const add = (val1, val2, fixed = 2) => {
    return toFixedFun((Number(val1) + Number(val2)), fixed)
}

// 减法
export const sub = (val1, val2, fixed = 2) => {
    return toFixedFun((Number(val1) - Number(val2)), fixed)
}

// 乘法
export const multi = (val1, val2, fixed = 2) => {
    return toFixedFun((Number(val1) * Number(val2)), fixed)
}

// 除法
export const divis = (val1, val2, fixed = 2) => {
    return toFixedFun((Number(val1) / Number(val2)), fixed)
}

// toFixed
export const toFixed = (val1, val2 = 2) => {
    try {
        return Number(val1).toFixed(val2)
    } catch (e) {
        return val1;
    }
}

// 解决1.005不会四舍五入 https://developer.aliyun.com/article/1078170
// 重写toFixed
export const toFixedFun = (data, len) => {
    // debugger
    const number = Number(data);
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }
    if (typeof (len) === 'undefined' || len === 0) {
        return (Math.round(number)).toString();
    }
    let result = number.toString();
    const numberArr = result.split('.');

    if (numberArr.length < 2) {
        // 整数的情况
        return padNum(result);
    }
    const intNum = numberArr[0]; // 整数部分
    const deciNum = numberArr[1];// 小数部分
    const lastNum = deciNum.substr(len, 1);// 最后一个数字

    if (deciNum.length === len) {
        // 需要截取的长度等于当前长度
        return result;
    }
    if (deciNum.length < len) {
        // 需要截取的长度大于当前长度 1.3.toFixed(2)
        return padNum(result);
    }
    // 需要截取的长度小于当前长度，需要判断最后一位数字
    result = `${intNum}.${deciNum.substr(0, len)}`;
    if (parseInt(lastNum, 10) >= 5) {
        // 最后一位数字大于5，要进位
        const times = Math.pow(10, len); // 需要放大的倍数
        let changedInt = Number(result.replace('.', ''));// 截取后转为整数
        changedInt++; // 整数进位
        changedInt /= times;// 整数转为小数，注：有可能还是整数
        result = padNum(`${changedInt}`);
    }
    return result;
    // 对数字末尾加0
    function padNum(num) {
        const dotPos = num.indexOf('.');
        if (dotPos === -1) {
            // 整数的情况
            num += '.';
            for (let i = 0; i < len; i++) {
                num += '0';
            }
            return num;
        } else {
            // 小数的情况
            const need = len - (num.length - dotPos - 1);
            for (let j = 0; j < need; j++) {
                num += '0';
            }
            return num;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/jsTool.js